import React, { FC } from 'react';
import { TrackerUtil } from '../../../../../tracking/TrackerUtil';
import InlineLink from './styled-components/InlineLink';

interface DataProcessingInlineLinkProps {
  linkText: string;
  handleOpenDpaViaWindow: () => void;
}

const DataProcessingInlineLink: FC<DataProcessingInlineLinkProps> = ({
  linkText,
  handleOpenDpaViaWindow
}) => {
  return (
    <InlineLink
      tabIndex={0}
      onClick={(event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        event.preventDefault(); // User clicked on link, so don't tick the box.
        TrackerUtil.trackLinkClick(`${TrackerUtil.getPageName()}_link_dpa`, 'link_dpa');
        handleOpenDpaViaWindow();
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          TrackerUtil.trackLinkClick(`${TrackerUtil.getPageName()}_link_dpa`, 'link_dpa');
          handleOpenDpaViaWindow();
        }
      }}
    >
      {linkText}
    </InlineLink>
  );
};

export default DataProcessingInlineLink;
